import { useParams, Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { getPlayer } from '../api/playersApi.js';
import './PlayerProfilePage.css';

function PlayerProfilePage() {
  const { slug } = useParams();
  const { data: player, loading } = useApi(() => getPlayer(slug), [slug]);

  if (loading) return <div className="pp-loading">載入中…</div>;
  if (!player) return null;

  return (
    <main className="v3-pp">
      <section className="pp-hero">
        <div className="pp-hero-inner">
          <div>
            <nav className="pp-crumbs">
              <Link to="/">首頁</Link> / <b>{player.name}</b>
            </nav>
            <p className="pp-eyebrow">{player.eyebrow}</p>
            <h1 className="pp-h1">{player.name}</h1>
            <p className="pp-en">{player.en}</p>
            <p className="pp-bio">{player.bio}</p>
            <dl className="pp-stats">
              {player.stats.map(s => (
                <div className="pp-stat" key={s.label}>
                  <dt>{s.label}</dt>
                  <dd>{s.value}</dd>
                </div>
              ))}
            </dl>
          </div>
          <div className="pp-hero-art" aria-hidden="true">
            <svg viewBox="0 0 200 360">
              <ellipse cx="100" cy="60" rx="34" ry="34" fill="#F5B815" opacity="0.85" />
              <path d="M 60 360 Q 70 180 100 165 Q 130 180 140 360 Z" fill="#F5B815" opacity="0.85" />
              <path d="M 100 165 L 175 130 L 185 120 L 110 155 Z" fill="#fff" />
              <circle cx="180" cy="124" r="9" fill="#E5002B" />
            </svg>
          </div>
        </div>
      </section>

      <div className="pp-body">
        <section className="pp-section">
          <h3>選手介紹</h3>
          {player.intro.map((p, i) => <p key={i}>{p}</p>)}
        </section>

        <section className="pp-section">
          <h3>賽事戰績 · 2024</h3>
          <ul>
            {player.achievements.map(a => <li key={a}>{a}</li>)}
          </ul>
        </section>

        <section className="pp-section">
          <h3>選手簽名款 · SIGNATURE</h3>
          <div className="pp-products">
            {player.products.map(p => (
              <Link to={`/product/${p.id}`} className="pp-prod" key={p.id}>
                <div className="pp-prod-img">
                  <svg viewBox="0 0 200 600" aria-hidden="true"><use href="#dart-full" /></svg>
                </div>
                <b>{p.name}</b>
                <span className="pp-price">NT${p.price.toLocaleString()}</span>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}

export default PlayerProfilePage;
